// 하단 액션바
import { useTranslation } from "react-i18next";
import styles from "../IntegratedSearchPage.module.css";
import { Icon } from "./Icons";

export function ActionFooter({ selectedCount, filteredCount, onClear, onExport, exporting }) {
    const { t } = useTranslation();
    const usingSelection = selectedCount > 0;
    const count = usingSelection ? selectedCount : filteredCount;
    return (
        <div className={styles.actionFooter}>
            <div className={styles.actionLeft}>
                <span className={usingSelection ? `${styles.countChip} ${styles.countChipActive}` : styles.countChip}>
                    <span>{count}</span>
                    <span className={styles.countChipLabel}>{usingSelection ? t('개 선택') : t('검색 결과')}</span>
                </span>
                <span className={styles.actionHint}>
                    {usingSelection
                        ? <><button onClick={onClear} className={styles.linkBtn}>{t('선택 해제')}</button></>
                        : <>{t('샘플을 선택하면 내려받을 수 있습니다')}</>}
                </span>
            </div>
            <div className={styles.actionRight}>
                <button className={styles.ghostBtn} onClick={onExport} disabled={!usingSelection || exporting}>
                    <Icon.Download /> {exporting ? t('내보내는 중…') : t('선택 항목 엑셀 내려받기')}
                </button>
            </div>
        </div>
    );
}

/* =============================================================
 * 상세 Drawer — 세부 NGS 코드 드롭다운 + WES/RNA/Drug 탭
 * ============================================================= */